import { AlertTriangle, Clock, Activity, Wrench } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";

const ServiceOrderDashboard = ({ serviceOrders }) => {
  // Calculate metrics from the service orders data

  const metricsData = [
    {
      title: "Open Orders",
      count: serviceOrders?.openOrders,
      trendSummary: "Currently open orders",
      icon: <Wrench className="h-8 w-8 text-blue-500" />,
      tooltip:
        "Number of service orders that are currently active and not yet completed.",
    },
    {
      title: "Overdue Orders",
      count: serviceOrders?.overdueOrders,
      trendSummary: "Past due date",
      icon: <AlertTriangle className="h-8 w-8 text-amber-500" />,
      tooltip: "Orders that have passed their due date without completion.",
    },
    {
      title: "Avg. Resolution Time",
      count: serviceOrders?.avgResolutionTimeDays,
      trendSummary: "Days to complete",
      icon: <Clock className="h-8 w-8 text-green-500" />,
      suffix: " Days",
      tooltip: "The average number of days taken to complete an order.",
    },
    {
      title: "High Priority",
      count: serviceOrders?.highPriorityOrders,
      trendSummary: "Urgent orders",
      icon: <Activity className="h-8 w-8 text-red-500" />,
      tooltip:
        "Urgent orders marked as high priority that require immediate attention.",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metricsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          trendSummary={stat.trendSummary}
          icon={stat.icon}
          tooltip={stat.tooltip}
        />
      ))}
    </div>
  );
};

export default ServiceOrderDashboard;
